import { useContext } from "react";

import { FormContext } from "../contexts";

/**
 * Hook to use the form context.
 * @throws Error if used outside of FormContext provider
 */
export const useForm = () => useContext(FormContext);
